export default {
  mutationSections(state, payload) {
    state.sections = payload;
  },
  mutationSectionsForm(state, payload) {
    state.sectionsForm = payload;
  },
  mutationSection(state, payload) {
    state.section = payload;
  },
};
